import { render, staticRenderFns } from "./ParticipantView.vue?vue&type=template&id=6043cb10&scoped=true"
import script from "./ParticipantView.vue?vue&type=script&lang=js"
export * from "./ParticipantView.vue?vue&type=script&lang=js"
import style0 from "./ParticipantView.vue?vue&type=style&index=0&id=6043cb10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6043cb10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6043cb10')) {
      api.createRecord('6043cb10', component.options)
    } else {
      api.reload('6043cb10', component.options)
    }
    module.hot.accept("./ParticipantView.vue?vue&type=template&id=6043cb10&scoped=true", function () {
      api.rerender('6043cb10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ParticipantView.vue"
export default component.exports